<template>
  <el-table-column
    prop="storage.name"
    label="Raktár"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.storage.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'storage.name',
  };
</script>
